import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "prevButton",
    "nextButton",
    "dropdownContainer",
    "inloopId",
    "activityId",
    "currentVersionNumber",
    "versionData",
    "versionOption"
  ]

  connect() {
  }

  disconnect() {
  }

  handleVersionSelect(event) {
    const versionId = event.currentTarget.dataset.versionId
    if (versionId) {
      this.navigateToVersion(versionId)
    }
  }

  goToPrevious(event) {
    event.preventDefault()
    event.stopPropagation()

    const currentNumber = parseInt(this.currentVersionNumberTarget.value)
    const previousVersion = this.findVersionByNumber(currentNumber - 1)

    if (previousVersion) {
      this.navigateToVersion(previousVersion.versionId)
    }
  }

  goToNext(event) {
    event.preventDefault()
    event.stopPropagation()

    const currentNumber = parseInt(this.currentVersionNumberTarget.value)
    const nextVersion = this.findVersionByNumber(currentNumber + 1)

    if (nextVersion) {
      this.navigateToVersion(nextVersion.versionId)
    }
  }

  findVersionByNumber(versionNumber) {
    const versionElement = this.versionDataTargets.find(el =>
      parseInt(el.dataset.versionNumber) === versionNumber
    )

    if (versionElement) {
      return {
        versionNumber: parseInt(versionElement.dataset.versionNumber),
        versionId: versionElement.dataset.versionId
      }
    }

    return null
  }

  navigateToVersion(versionId) {
    const inloopId = this.inloopIdTarget.value
    const activityId = this.activityIdTarget.value
    const url = `/facilitator/inloops/${inloopId}/activities/${activityId}/preview_mode/document_validation?version_id=${versionId}`

    window.location.href = url
  }
}
